import { CollectionManagementResult } from './collectionManagementResult.model';

export class CollectionManagement {
  idCollectionManagement: number
  mailingNumber: number
  managementDate?: Date
  fkNameUser: string
  fkIdUser: number
  fkIdManagementResult: number
  managementObservation: string
  fkIdDocumentSource?: number
  documentSourceName?: string
  documentNumber?: string
  noveltyValue?: number
  dateAgreement?: Date
  fkIdPortfolio: string
  lock: boolean = false
  managementResult: CollectionManagementResult
}


